export function addCurrent(calledclosingstatus) {
  return {
      type: 'ADD_CURRENT',
      calledclosingstatus,
  }
}